import PropTypes from 'prop-types';
import { Component } from 'react';

class ContextProvider extends Component {
    static genericTypes = [PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.object];

    static contextType = {
        isBrowser: PropTypes.bool.isRequired,
        isPreview: PropTypes.bool.isRequired,
        hostname: PropTypes.string.isRequired,
        isSecure: PropTypes.bool.isRequired,
        apiPrefixInternal: PropTypes.string.isRequired,
        deviceType: PropTypes.objectOf(PropTypes.bool).isRequired,
        staticRoutes: PropTypes.oneOfType([PropTypes.object]).isRequired,
        featureFlags: PropTypes.oneOfType([PropTypes.object]).isRequired,
        env: PropTypes.string,
        query: PropTypes.objectOf(PropTypes.object),
        headers: PropTypes.objectOf(PropTypes.object),
        apiVersion: PropTypes.string,
        staticRoute: PropTypes.string,
        preOps: PropTypes.oneOfType([PropTypes.object]),
        reqId: PropTypes.string,
        micrositeSVGSprite: PropTypes.oneOfType([PropTypes.array]),
        preferences: PropTypes.oneOfType([PropTypes.object]),
        __RELEASEVERSION__: PropTypes.string,
        requestUrl: PropTypes.string,
        esiHeaderRequiredRoutes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        isABTestOn: PropTypes.bool,
        tzOffset: PropTypes.number,
        isContextHeadersRequired: PropTypes.bool,
        abTestEngagements: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        isFusionEnabled: PropTypes.bool,
        isHomeOffice: PropTypes.bool,
        cssContents: PropTypes.string,
        cluster: PropTypes.string,
        isInlineStylesPrefetched: PropTypes.bool,
        isSiteComponentsStylesFetched: PropTypes.bool,
        refererUrl: PropTypes.string,
    };

    static ContextType = PropTypes.shape(ContextProvider.contextType);

    static childContextTypes = ContextProvider.contextType;

    static propTypes = {
        context: ContextProvider.ContextType.isRequired,
        children: PropTypes.element.isRequired,
    };

    getChildContext() {
        const { context } = this.props;
        return context;
    }

    render() {
        const { children } = this.props;
        return children;
    }
}

export default ContextProvider;
